import React from 'react';
import ReactDOM from 'react-dom';

/**
 * @desc Bootstrap a react component inside a HTML element. This is entry point of the application.
 * @param {*} Component - React component
 * @param {*} element - DOM element or HTML element id
 * @param {*} defaultProps - Default props passed to the Component
 * @example
 * import { bootstrap } from 'core/bootstrap';
 * bootstrap( App, 'app' );
 */
export const bootstrap = ( Component, element, defaultProps = {} ) => {

    // if element is a string, use it as `id` to get `DOM` element
    if( 'string' === typeof element ) {
        element = document.getElementById( element );
    }

    // render `Component` using `ReactDOM.render`
    ReactDOM.render( <Component { ...defaultProps } />, element );
};

